import React, { useRef, useEffect, useState } from "react";
import { FormField, Button, Box } from "@nef/core";
import { useWizard } from "react-use-wizard";
import { useForm, Controller, useFormContext, useFormState } from "react-hook-form";

import StyledInformationCollection from "../../../../../styles/InformationCollection.styles";
import { EMAIL_REGEX } from "../../../../../constants/regexRepo";
import CountrySelector from "../../../../../components/common/CountrySelector";
import CountryRegionSelector from "../../../../../components/common/CountryRegionSelector";

const InformationCollection = () => {
  const { control, getValues, setValue, getFieldState, formState: { errors, isDirty }, trigger, clearErrors } = useFormContext();
  const { nextStep } = useWizard();
  const buttonRef = useRef(null);

  const handleNext = async () => {
    const isValid = await trigger();
    if (isValid) {
      nextStep();
    }
  }

  return (
    <>
      <StyledInformationCollection className="information-collection">
        <Controller
          name="firstName"
          control={control}
          rules={{ required: true, minLength: 1 }}
          render={({ field: { onChange, value, name }, fieldState, formState }) => (
            <FormField
              className="form-field"
              label="First Name"
              name={name}
              value={value}
              invalid={fieldState.error != null}
              feedback={fieldState.error?.message}
              onChange={onChange}
            />
          )}
        />
        <Controller
          name="lastName"
          control={control}
          rules={{ required: true, minLength: 1 }}
          render={({ field: { onChange, value, name }, fieldState, formState }) => (
            <FormField
              className="form-field"
              label="Last Name"
              name={name}
              value={value}
              invalid={fieldState.error != null}
              feedback={fieldState.error?.message}
              onChange={onChange}
            />
          )}
        />
        <Controller
          name="title"
          control={control}
          rules={{ required: true, minLength: 1 }}
          render={({ field: { onChange, value, name }, fieldState, formState }) => (
            <FormField
              className="form-field"
              label="Title"
              name={name}
              value={value}
              invalid={fieldState.error != null}
              feedback={fieldState.error?.message}
              onChange={onChange}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{
            required: true,
            pattern: { value: EMAIL_REGEX, message: "Invalid Email Format" },
            minLength: { value: 6, message: "minimum email length should be atleast 6 characters " }
          }
          }
          render={({ field: { onChange, value, name }, fieldState, formState }) => (
            <FormField
              className="form-field"
              label="Email"
              name={name}
              value={value}
              invalid={fieldState.error != null}
              feedback={fieldState.error?.message}
              onChange={onChange}
            />
          )}
        />
        <Controller
          name="organizationName"
          control={control}
          rules={{
            required: true,
            minLength: { value: 1, message: "Organization Name is required" },
            maxLength: { value: 75, message: "Organization Name should be less then 76 characters" }
          }}
          render={({ field: { onChange, value, name }, fieldState, formState }) => (
            <FormField
              className="form-field"
              label="Organization Name"
              name={name}
              value={value}
              invalid={fieldState.error != null}
              feedback={fieldState.error?.message}
              onChange={onChange}
            />
          )}
        />
        <CountryRegionSelector control={control} setValue={setValue} clearErrors={clearErrors} />
       
        <Button className="button" size="lg" onClick={handleNext}>
          Next
        </Button>
      </StyledInformationCollection>
    </>
  );
};
export default InformationCollection;
